export const ScanKizConfirmationViewPluginSettings: IPluginSettings = {
    name: 'Подтверждение КИЗ',
    mnemocode: 'scan_kiz_confirm_plugin',
    columns: [
        {
            order: 0,
            propertyName: 'infoSupplier',
            propertyType: 'string',
            displayName: 'Информация от поставщика',
            visibility: true,
            width: 200
        },
        {
            order: 1,
            propertyName: 'infoScanned',
            propertyType: 'string',
            displayName: 'Отсканированный КИЗ',
            visibility: true,
            width: 200
        },
    ]
}